function restoreHeaderSearch() {
    try {
        // Mostrar barra de búsqueda del header
        const searchBar = document.querySelector('.search-pill-form');
        if (searchBar) {
            searchBar.style.display = 'flex';
            searchBar.classList.remove('hidden', 'is-hidden');
        }

        // Cerrar modal de búsqueda si sigue activo
        const searchModal = document.querySelector('#search-drawer, [data-search-modal]');
        if (searchModal) {
            searchModal.removeAttribute('open');
            searchModal.classList.remove('active', 'is-open');
        }

        // Quitar clases que el theme pone cuando abre el search
        document.body.classList.remove(
            'search-modal-open', 
            'search-open',
            'overflow-hidden'
        );
        document.documentElement.classList.remove(
            'search-modal-open', 
            'search-open',
            'overflow-hidden'
        );

    } catch (e) {
        console.error('Error restoring search bar:', e);
    }
}

const headless = {
  url: "https://shasamx.myshopify.com/api/2024-07/graphql.json",
  hash: "a8ea2c7f8c33041181cc09f1d64b35c5",
  fetch: async (query) => {
    const request = {
      async: true,
      crossDomain: true,
      method: "POST",
      headers: {
        "X-Shopify-Storefront-Access-Token": headless.hash,
        "Content-Type": "application/graphql",
      },
      body: query,
    };
    const response = await fetch(headless.url, request);
    const res = await response.json();
    if (res.data?.nodes) return res.data.nodes;
    else if (res.data) return res.data;
    else return res;
  },
};
const cart = {
  drawer: null,
  add: (variantId, productId, attributionKey, source, loadingButton) => {
  console.log(cart);
  console.log(cart?.drawer);

  const drawer = cart?.drawer;

  let sectionsIds = null;
  if (drawer && typeof drawer.getSectionsToRender === "function") {
    const sections = drawer.getSectionsToRender();
    if (Array.isArray(sections)) {
      sectionsIds = sections.map((s) => s?.id).filter(Boolean);
    }
  }

  const formData = {
    id: variantId,
    quantity: 1,
    ...(sectionsIds && sectionsIds.length ? { sections: sectionsIds } : {}),
  };


  fetch(routes.cart_add_url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then(async (response) => {
      console.log('Se agregó al carrito')
      trackGA4AddToCart('plp');
      if (attributionKey) {
        // Atribución del quick-buy
        nostojs((api) => {
          api
            .recordAttribution({
              type: "cp",
              target: String(productId),
              ref: String(attributionKey),
              refType: "api",
            })
            .done();
        });
        /*nostojs((api) => {
          try {
            api.recommendedProductAddedToCart(String(productId), String(attributionKey)).done();
          } catch (e) {
            console.warn("Nosto recommendedProductAddedToCart falló:", e);
          }
        });*/

        const newCart = await getCurrentCart();
        const currencyCode = newCart?.currency || newCart?.attributes?.currency || "MXN";

        nostojs((api) => {
          api
            .defaultSession()
            .setCart({
              items: (newCart.items || []).map((item) => ({
                product_id: String(item.product_id),
                name: String(item.product_title),
                sku_id: String(item.sku),
                quantity: Number(item.quantity),
                unit_price: Number(item.price) / 100,
                price_currency_code: String(currencyCode),
              })),
            })
            .viewCart()
            .update();
        });

      }
      if (source == "nostosearch") {
        const hit = search.hitsByProductId.get(String(productId));

        if (!hit) {
          console.warn("No search hit found for", productId);
          return;
        }

        const isSearchPage =
          window.location.pathname.includes('/search');

        const track = isSearchPage
          ? 'serp'
          : 'autocomplete';

        nostojs(api => { 
          api.recordSearchAddToCart(track, hit); 
        }); 
      }
      if (source == "category") {
        nostojs(api => { 
          api.recordSearchAddToCart('category', category.hitsByProductId.get(String(productId))); 
        }); 
      }

      if (drawer && typeof drawer.renderContents === "function") {
        try {
          drawer.renderContents(response);
          setTimeout(() => {
            if (loadingButton) {
              loadingButton.classList.remove("is-loading");
              loadingButton.disabled = false;
            }

            const modal = document.getElementById("quickAddModal");
            if (modal) {
              modal.classList.remove("is-open");
              modal.setAttribute("aria-hidden", "true");
              document.body.classList.remove("quick-add-open");
            }
          }, 150);
        } catch (e) {
          console.warn("drawer.renderContents falló, pero el add-to-cart sí ocurrió:", e);
        }
      } else {
        console.warn("No hay drawer/renderContents disponible. Producto agregado, sin drawer.");
      }
      setTimeout(() => {

        if (loadingButton) {
          loadingButton.classList.remove("is-loading");
          loadingButton.disabled = false;
        }
        const modal = document.getElementById("quickAddModal");
        if (modal) {
          modal.classList.remove("is-open");
          modal.setAttribute("aria-hidden", "true");
          document.body.classList.remove("quick-add-open");
        }
        updateCart()
      }, 150);

      try { ncaddToken(); } catch (e) { console.warn("ncaddToken falló:", e); }
      try { uploadCart(); } catch (e) { console.warn("uploadCart falló:", e); }
      try { executeInCartUpdate(); } catch (e) { console.warn("executeInCartUpdate falló:", e); }
    })
    .catch((error) => {
      console.error("Error:", error);

      if (loadingButton) {
        loadingButton.classList.remove("is-loading");
        loadingButton.disabled = false;
      }
      const modal = document.getElementById("quickAddModal");
      if (modal) {
        modal.classList.remove("is-open");
        modal.setAttribute("aria-hidden", "true");
        document.body.classList.remove("quick-add-open");
      }
    });
},
};
class Card {
  constructor(id, container, source, attributionKey, useParent, parent) {
    this.id = id;
    this.container = document.getElementById(container);
    this.containerId = container
    this.source = source;
    this.attributionKey = attributionKey ? `?nosto=${attributionKey}` : "";
    this.carousel = attributionKey || "";
    this.useParent = useParent
    this.parent = parent
    this.create();
  }
  async create() {
    const query = `
      query {
        product(id: "gid://shopify/Product/${this.id}") {
          gid: id
          title
          list: metafield(namespace: "custom", key: "product_list") {
            value
          }
          color: metafield(namespace: "custom", key: "color") {
            value
          }
        }
      }
    `;
    const { product } = await headless.fetch(query);
    if (product && product.gid) {
      product.id = product.gid.split("/").at(-1);
      if(!product.list){
        product.list = { value: JSON.stringify([product.gid]) };
      }
      const query = `
        query {
          nodes(ids: ${product.list.value}) {
            ... on Product {
              id
              onlineStoreUrl
              color: metafield(namespace: "custom", key: "color") {
                value
              }
              tags
              images(first: 2) {
                edges {
                  node {
                    url
                    altText
                  }
                }
              }
              collections(first: 25) {
                edges {
                  node {
                    id
                    handle
                    title
                  }
                }
              }
              variants(first: 20) {
                edges {
                  node {
                    id
                    title
                    availableForSale
                    quantityAvailable
                    price{
                      amount
                    }
                    compareAtPrice{
                      amount
                    }
                  }
                }
              }
            }
          }
        }
      `;
      const productList = await headless.fetch(query);
    //Caso especial para gift card
    if(String(product.id) === '8700344402132'){
      const giftCard = productList[0]
      const card = document.createElement("div");
      card.className = "card";
      card.innerHTML = `
        <div>
            <label class="card-product giftcard-card">
              <input type="radio" class="hidden" id="${this.carousel}-${product.id}" name="${this.carousel}-${product.id}">
              <a
              ${this.source === "nostosearch"
              ? `href="${giftCard.onlineStoreUrl}?&fromnostosearch=true" onclick="window.recordClick('serp','${product.id}')"`
              : `href="${giftCard.onlineStoreUrl}${this.attributionKey}"`
              }>
                <img loading="lazy" src="${giftCard.images.edges[0].node.url}&width=600" alt="${product.title}" />
                ${this.source === 'nostosearch' ? `<span class="card-title">${product.title}</span>` : `<h3 class="card-title" style="margin:0; font-size:inherit; font-weight:inherit; line-height:inherit; letter-spacing:inherit; display:block;">${product.title}</h3>`}
                <div class="flex price-container">
                  <p>$${giftCard.variants.edges[0].node.price.amount}0 - $${giftCard.variants.edges[giftCard.variants.edges.length - 1].node.price.amount}0</p>
                </div>
              </a>
            </label>
        </div>
      `;
      if(this.useParent){
        const parentId = this.parent.replace(/^#/, '');
        const containerId = this.containerId.replace(/^#/, '');

        const parentEl = document.getElementById(parentId);

        const containerEl = parentEl.querySelector(`[id="${containerId}"]`);

        containerEl.replaceChildren(card);
      }
      else{
        this.container.replaceChildren(card);
      }
      return
    }
      const productColors = [];
      for (const product_element of productList) {
        if (product_element && product_element.images.edges.length > 0) {
          const masVendido = product_element.collections?.edges?.some(c => c.node.handle === "los-mas-vendidos") || false;
          const compareAtPrice = product_element.variants.edges[0].node.compareAtPrice?.amount;
          const productDetails = {
            id: product_element.id.split("/").at(-1),
            color: product_element.color.value,
            class: product_element.color.value
              .trim()
              .replace(/[^a-zA-Z]/g, "")
              .toLowerCase(),
            image: product_element.images.edges[0].node.url,
            hoverImage: product_element.images.edges[1]?.node?.url || "",
            tags: product_element.tags || [],
            url: product_element.onlineStoreUrl,
            price: product_element.variants.edges[0].node.price.amount,
            compareAtPrice: compareAtPrice ? `$${compareAtPrice}0` : "",
            variants: product_element.variants.edges
              .map((variant) => {
                return {
                  title: variant.node.title,
                  id: variant.node.id.split("/").at(-1),
                  availableForSale: variant.node.availableForSale,
                };
              })
              .filter((variant) => variant.availableForSale),
            tagMasVendido: masVendido,
            stock: product_element.variants?.edges?.reduce((s, v) => s + (v.node.quantityAvailable || 0), 0) || 0,
          };
          if (compareAtPrice) {
            productDetails.discount = Math.ceil(100-((productDetails.price / compareAtPrice) * 100))
          }
          productColors.push(productDetails);
        }
      }
      if (productColors.length > 1) {
        const index = productColors.findIndex(
          (p) => p.color == product.color.value
        );
        productColors.unshift(productColors.splice(index, 1)[0]);
      }
      const quickAddColorsData = productColors.map((pc) => ({
        id: pc.id,
        color: pc.color,
        class: pc.class,
        image: `${pc.image}&width=130`,
        url: pc.url,
        price: pc.price,
        hoverImage: pc.hoverImage
          ? `${pc.hoverImage}&width=130`
          : null,
        compareAtPrice: pc.compareAtPrice || "",
        variants: pc.variants || [],
        tagMasVendido: pc.tagMasVendido || false,
        stock: pc.stock || 0,
        discount: pc.discount || null,
      }));
      const activeColor = productColors[0];
      const cardLink = buildProductCardHref({
        source: this.source,
        productColor: activeColor,
        attributionKey: this.attributionKey,
        carousel: this.carousel
      });
      const card = document.createElement("div");
      const isLoggedIn = !!(window.wishlist_parse && window.wishlist_parse.items);
      card.className = "card";
      card.innerHTML = `
  <div
    class="card-content product-card-shell"
    data-product-id="${product.id}"
    data-source="${this.source}"
    data-carousel="${this.carousel}"
    data-attribution="${this.attributionKey.replace('?nosto=','')}"
    data-colors='${escapeHtml(JSON.stringify(quickAddColorsData))}'
  >
    <label class="card-product ${activeColor.stock} ${activeColor.variants.length === 0 ? "unavailable" : ""}">
    ${ activeColor.tags.includes('CODE_HYPSTERS') ? `
                                            <div class="card-badge-hypsters"  style="bottom:150px " >
                                            <svg width="100" height="36" viewBox="0 0 100 36" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M100 0H0V36H100V0Z" fill="#000000"/>
  <path d="M8 26.5724V10.1868H10.5748V17.2089H13.5008V10.1868H16.1227V26.5724H13.5008V19.5503H10.5748V26.5724H8Z" fill="white"/>
  <path d="M19.025 10.1868H21.7171L23.6832 17.6543L25.6494 10.1868H28.1075L24.8534 21.1418V26.5724H22.2786V21.1418L19.025 10.1868Z" fill="white"/>
  <path d="M37.6815 11.2168C38.3212 11.9035 38.6413 12.9099 38.6413 14.2364V16.3664C38.6413 17.6934 38.3212 18.6992 37.6815 19.386C37.0413 20.0728 36.082 20.4159 34.8021 20.4159H33.5848V26.5719H31.01V10.1863H34.8021C36.0815 10.1863 37.0413 10.5294 37.6815 11.2162V11.2168ZM33.5848 18.0751H34.8021C35.2234 18.0751 35.5392 17.9578 35.7501 17.7239C35.961 17.49 36.0659 17.0922 36.0659 16.5302V14.0721C36.0659 13.51 35.9605 13.1123 35.7501 12.8783C35.5392 12.6439 35.2234 12.5272 34.8021 12.5272H33.5848V18.0751Z" fill="white"/>
  <path d="M42.4562 11.0647C43.0959 10.3544 44.0402 10 45.2885 10C46.5369 10 47.4806 10.3549 48.1208 11.0647C48.7605 11.7751 49.0806 12.7932 49.0806 14.1192V14.6341H46.6461V13.9554C46.6461 13.3933 46.5369 12.9843 46.3185 12.7263C46.0995 12.4688 45.7799 12.3403 45.3587 12.3403C44.9374 12.3403 44.6173 12.4688 44.3989 12.7263C44.1799 12.9838 44.0712 13.3933 44.0712 13.9554C44.0712 14.6421 44.2543 15.2433 44.621 15.7583C44.9877 16.2727 45.538 16.8583 46.2713 17.5135C46.88 18.0756 47.3714 18.5707 47.7461 18.9995C48.1208 19.4288 48.4404 19.9475 48.7059 20.5562C48.9709 21.1643 49.1042 21.8591 49.1042 22.639C49.1042 23.9655 48.7766 24.9842 48.1208 25.6935C47.4656 26.4038 46.5133 26.7587 45.265 26.7587C44.0161 26.7587 43.0643 26.4038 42.4091 25.6935C41.7534 24.9837 41.4258 23.9655 41.4258 22.639V21.6327H43.8603V22.8034C43.8603 23.8649 44.3052 24.3954 45.1943 24.3954C46.084 24.3954 46.5288 23.8649 46.5288 22.8034C46.5288 22.1166 46.3452 21.516 45.9785 21.001C45.6119 20.4861 45.0616 19.901 44.3282 19.2452C43.7196 18.6832 43.2281 18.1885 42.8534 17.7592C42.4787 17.3304 42.1591 16.8112 41.8936 16.2026C41.6281 15.5939 41.4954 14.8996 41.4954 14.1192C41.4954 12.7932 41.8149 11.7745 42.4552 11.0647H42.4562Z" fill="white"/>
  <path d="M59.661 10.1868V12.5277H56.969V26.5725H54.3942V12.5272H51.7021V10.1863H59.661V10.1868Z" fill="white"/>
  <path d="M68.767 17.0922V19.4331H65.2324V24.2316H69.6802V26.5724H62.6576V10.1868H69.6802V12.5277H65.2324V17.0922H68.767Z" fill="white"/>
  <path d="M78.3404 25.8236C78.3094 25.5891 78.2938 25.1678 78.2938 24.5592V21.9844C78.2938 21.2349 78.1611 20.7007 77.8956 20.3806C77.6301 20.061 77.2013 19.901 76.6082 19.901H75.7185V26.5724H73.1437V10.1868H77.0294C78.3554 10.1868 79.3232 10.4951 79.9319 11.1118C80.5405 11.728 80.8445 12.6765 80.8445 13.9559V15.2438C80.8445 16.929 80.2825 18.0376 79.1589 18.5675C79.7675 18.817 80.2043 19.2345 80.4698 19.8201C80.7348 20.4052 80.8676 21.1504 80.8676 22.0556V24.5838C80.8676 25.0522 80.8831 25.4306 80.9147 25.7192C80.9457 26.0082 81.0233 26.293 81.1486 26.5735H78.5267C78.433 26.3085 78.3704 26.0586 78.3393 25.8246L78.3404 25.8236ZM75.719 17.5601H76.7254C77.2404 17.5601 77.6263 17.4273 77.8843 17.1623C78.1418 16.8968 78.2708 16.452 78.2708 15.8278V14.2128C78.2708 13.6197 78.1654 13.1909 77.955 12.9249C77.7441 12.6599 77.4127 12.5272 76.9599 12.5272H75.719V17.5601Z" fill="white"/>
  <path d="M85.0584 11.0647C85.6981 10.3544 86.6424 10 87.8907 10C89.139 10 90.0828 10.3549 90.723 11.0647C91.3627 11.7751 91.6828 12.7932 91.6828 14.1192V14.6341H89.2482V13.9554C89.2482 13.3933 89.139 12.9843 88.9206 12.7263C88.7017 12.4688 88.3821 12.3403 87.9608 12.3403C87.5395 12.3403 87.2194 12.4688 87.001 12.7263C86.7821 12.9838 86.6734 13.3933 86.6734 13.9554C86.6734 14.6421 86.8565 15.2433 87.2232 15.7583C87.5899 16.2727 88.1402 16.8583 88.8735 17.5135C89.4822 18.0756 89.9736 18.5707 90.3483 18.9995C90.723 19.4288 91.0426 19.9475 91.3081 20.5562C91.5731 21.1643 91.7063 21.8591 91.7063 22.639C91.7063 23.9655 91.3787 24.9842 90.723 25.6935C90.0678 26.4038 89.1155 26.7587 87.8671 26.7587C86.6183 26.7587 85.6665 26.4038 85.0113 25.6935C84.3556 24.9837 84.028 23.9655 84.028 22.639V21.6327H86.4625V22.8034C86.4625 23.8649 86.9074 24.3954 87.7965 24.3954C88.6862 24.3954 89.131 23.8649 89.131 22.8034C89.131 22.1166 88.9474 21.516 88.5807 21.001C88.214 20.4861 87.6637 19.901 86.9304 19.2452C86.3217 18.6832 85.8303 18.1885 85.4556 17.7592C85.0809 17.3304 84.7613 16.8112 84.4958 16.2026C84.2303 15.5939 84.0975 14.8996 84.0975 14.1192C84.0975 12.7932 84.4171 11.7745 85.0573 11.0647H85.0584Z" fill="white"/>
</svg>
</div> ` : `` }
      <input
        type="radio"
        class="hidden"
        id="${this.carousel}-${activeColor.class}-${product.id}"
        name="${this.carousel}-${product.id}"
        value="${activeColor.color}"
        checked
      >

      <div class="wishlist-btn-wrap card-wishlist-slot">
        ${buildWishlistButton({ product, productColor: activeColor, isLoggedIn })}
      </div>

      <a
        class="card-main-link"
        href="${cardLink}"
        ${this.source === "nostosearch"
          ? `onclick="window.recordClick('serp','${activeColor.id}')"`
          : this.source === "category"
          ? `onclick="window.recordClick('category', '${activeColor.id}')"`
          : `data-nosto-rec-click="1"
            data-nosto-product-id="${activeColor.id}"
            data-nosto-ref="${this.carousel}"
            onclick="window.recordRecClick('${activeColor.id}', this.href, '${this.carousel}', event)"`}
      >
        <div class="card-image-wrap">
          <img
            class="card-main-image card-image-primary"
            loading="lazy"
            src="${activeColor.image}&width=600"
            alt="${escapeHtml(product.title)}"
          />

          ${
            activeColor.hoverImage
              ? `
              <img
                class="card-hover-image card-image-secondary"
                loading="lazy"
                src="${activeColor.hoverImage}&width=600"
                alt="${escapeHtml(product.title)}"
              />
            `
              : ""
          }
        </div>

        ${this.source === 'nostosearch' ? `<div class="card-title card-title-slot" style="margin:10px 0 0;">${product.title}</div>` : `<h3 class="card-title card-title-slot" style="margin:10px 0 0; font-size:inherit; font-weight:inherit; line-height:inherit; letter-spacing:inherit;">${product.title}</h3>`}

        <div class="flex price-container card-price-slot">
          ${buildProductCardPriceHtml(activeColor)}
        </div>
      </a>

    ${buildCardSwatches({
      productColors,
      carousel: this.carousel,
      product,
      source: this.source,
      attributionKey: this.attributionKey
    })}

      <button
        type="button"
        class="quick-add-trigger-btn card-quick-add-slot"
        data-title="${encodeURIComponent(product.title)}"
        data-colors='${encodeURIComponent(JSON.stringify(quickAddColorsData))}'
        data-selected-color-id="${activeColor.id}"
        data-container-id="${this.id}"
        data-product-id="${activeColor.id}"
        data-attribution="${encodeURIComponent(this.attributionKey.replace('?nosto=',''))}"
        data-source="${this.source}"
        onclick="openProductQuickAdd(event, this)"
      >
        <span class="card-quick-add-text">Añadir</span>
        <span class="card-quick-add-spinner" aria-hidden="true"></span>
 <svg width="19" height="19" viewBox="0 0 18 18" style="margin-left: 5px;margin-bottom: 5px;" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_626_324" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="19" height="19">
<rect width="19" height="19" fill="#D9D9D9"/>
</mask>
<g mask="url(#mask0_626_324)">
<path d="M4.81857 16.2857C4.48339 16.2857 4.1997 16.169 3.96747 15.9357C3.73525 15.7024 3.61914 15.4173 3.61914 15.0805V7.49085C3.61914 7.15407 3.73525 6.86902 3.96747 6.63569C4.1997 6.40235 4.48339 6.28569 4.81857 6.28569H6.10724V6.11902C6.10724 5.42846 6.35007 4.83913 6.83575 4.35102C7.32154 3.86302 7.90806 3.61902 8.59533 3.61902C9.2826 3.61902 9.86913 3.86302 10.3549 4.35102C10.8406 4.83913 11.0834 5.42846 11.0834 6.11902V6.28569H12.3721C12.7073 6.28569 12.991 6.40235 13.2232 6.63569C13.4554 6.86902 13.5715 7.15407 13.5715 7.49085V15.0805C13.5715 15.4173 13.4554 15.7024 13.2232 15.9357C12.991 16.169 12.7073 16.2857 12.3721 16.2857H4.81857ZM4.81857 15.2857H12.3721C12.4232 15.2857 12.47 15.2643 12.5124 15.2215C12.555 15.1789 12.5763 15.1319 12.5763 15.0805V7.49085C12.5763 7.43952 12.555 7.39252 12.5124 7.34985C12.47 7.30707 12.4232 7.28569 12.3721 7.28569H11.0834V8.78569C11.0834 8.92757 11.0358 9.04635 10.9404 9.14202C10.8452 9.2378 10.727 9.28569 10.5858 9.28569C10.4446 9.28569 10.3264 9.2378 10.2312 9.14202C10.1358 9.04635 10.0882 8.92757 10.0882 8.78569V7.28569H7.10247V8.78569C7.10247 8.92757 7.05481 9.04635 6.95949 9.14202C6.86428 9.2378 6.74607 9.28569 6.60486 9.28569C6.46364 9.28569 6.34543 9.2378 6.25022 9.14202C6.1549 9.04635 6.10724 8.92757 6.10724 8.78569V7.28569H4.81857C4.76748 7.28569 4.7207 7.30707 4.67824 7.34985C4.63567 7.39252 4.61438 7.43952 4.61438 7.49085V15.0805C4.61438 15.1319 4.63567 15.1789 4.67824 15.2215C4.7207 15.2643 4.76748 15.2857 4.81857 15.2857ZM7.10247 6.28569H10.0882V6.11902C10.0882 5.70113 9.94338 5.34663 9.65377 5.05552C9.36415 4.76452 9.01134 4.61902 8.59533 4.61902C8.17932 4.61902 7.82651 4.76452 7.5369 5.05552C7.24728 5.34663 7.10247 5.70113 7.10247 6.11902V6.28569Z" fill="white"/>
</g>
</svg>
      </button>

      ${activeColor.discount ? `
        <div class="discount-label sale">-${activeColor.discount}%</div>
      ` : ``}

      ${!activeColor.discount && globalDiscount ? `
        <div class="discount-label event">
          <img loading="lazy" src="https://cdn.shopify.com/s/files/1/0676/3433/1860/files/Logo_Hot_sale.png?v=1779492334" alt="Hot Sale">
        </div>
      ` : `
      `}
    </label>
  </div>
`;
      // console.log('CONTAINER')
      // console.log(this.container)
      let hasStock = false
      for (const productVariant of productColors) {
        if (productVariant.stock > 0) {
          hasStock = true
          break
        }
        let withStock = productVariant.variants.filter((v) => v.availableForSale)
        if (withStock.length > 0) {
          hasStock = true
          break
        }
      }
      if(hasStock) {
        if(this.useParent){
          const parentId = this.parent.replace(/^#/, '');
          const containerId = this.containerId.replace(/^#/, '');

          const parentEl = document.getElementById(parentId);

          const containerEl = parentEl.querySelector(`[id="${containerId}"]`);

          containerEl.replaceChildren(card);
        }
        else{
          this.container.replaceChildren(card);
        }
      }
    }
  }
}
window.addEventListener("load", () => {
  cart.drawer = document.querySelector("cart-drawer");
});

function buildProductCardHref({ source, productColor, attributionKey, carousel }) {
  if (source === "nostosearch") {
    return `${productColor.url}?&fromnostosearch=true`;
  }

  if (source === "category") {
    return `${productColor.url}?&fromnostocategory=true`;
  }

  return `${productColor.url}${attributionKey || ""}`;
}

window.changeProductCardColor = function (event, button) {
  event.preventDefault();
  event.stopPropagation();

  const shell = button.closest(".product-card-shell");
  if (!shell) return;

  const colors = JSON.parse(shell.dataset.colors || "[]");
  const colorId = button.dataset.colorId;

  const colorData =
    colors.find((color) => String(color.id) === String(colorId)) || colors[0];

  if (!colorData) return;

  const source = shell.dataset.source || "";
  const carousel = shell.dataset.carousel || "";
  const attribution = shell.dataset.attribution ? `?nosto=${shell.dataset.attribution}` : "";

  const mainLink = shell.querySelector(".card-main-link");
  const imageEl = shell.querySelector(".card-main-image");
  const priceSlot = shell.querySelector(".card-price-slot");
  const quickAddBtn = shell.querySelector(".card-quick-add-slot");

  const newHref = buildProductCardHref({
    source,
    productColor: colorData,
    attributionKey: attribution,
    carousel
  });

  if (mainLink) {
    mainLink.setAttribute("href", newHref);

    if (source === "nostosearch") {
      mainLink.setAttribute("onclick", `window.recordClick('serp','${colorData.id}')`);
      mainLink.removeAttribute("data-nosto-rec-click");
      mainLink.removeAttribute("data-nosto-product-id");
      mainLink.removeAttribute("data-nosto-ref");
    } else if (source === "category") {
      mainLink.setAttribute("onclick", `window.recordClick('category', '${colorData.id}')`);
      mainLink.removeAttribute("data-nosto-rec-click");
      mainLink.removeAttribute("data-nosto-product-id");
      mainLink.removeAttribute("data-nosto-ref");
    } else {
      mainLink.setAttribute("data-nosto-rec-click", "1");
      mainLink.setAttribute("data-nosto-product-id", colorData.id);
      mainLink.setAttribute("data-nosto-ref", carousel);
      mainLink.setAttribute(
        "onclick",
        `window.recordRecClick('${colorData.id}', this.href, '${carousel}', event)`
      );
    }
  }

  const hoverImageEl = shell.querySelector(".card-hover-image");

if (imageEl) {
  imageEl.src = `${colorData.image}&width=600`;
}

if (hoverImageEl) {
  if (colorData.hoverImage) {
    hoverImageEl.src = colorData.hoverImage.includes("width=")
      ? colorData.hoverImage.replace(/width=\d+/, "width=600")
      : `${colorData.hoverImage}&width=600`;

    hoverImageEl.style.display = "";
  } else {
    hoverImageEl.removeAttribute("src");
    hoverImageEl.style.display = "none";
  }
}

  if (priceSlot) {
    priceSlot.innerHTML = buildProductCardPriceHtml(colorData);
  }

  if (quickAddBtn) {
    quickAddBtn.dataset.selectedColorId = colorData.id;
    quickAddBtn.dataset.productId = colorData.id;
  }

  shell.querySelectorAll(".card-color-swatch").forEach((swatch) => {
    swatch.classList.toggle(
      "is-active",
      String(swatch.dataset.colorId) === String(colorData.id)
    );
  });

  const moreBtn = shell.querySelector(".card-color-more");
  if (moreBtn) {
    moreBtn.setAttribute("href", newHref);

    if (source === "nostosearch") {
      moreBtn.setAttribute("onclick", `window.recordClick('serp','${colorData.id}')`);
      moreBtn.removeAttribute("data-nosto-rec-click");
      moreBtn.removeAttribute("data-nosto-product-id");
      moreBtn.removeAttribute("data-nosto-ref");
    } else if (source === "category") {
      moreBtn.setAttribute("onclick", `window.recordClick('category','${colorData.id}')`);
      moreBtn.removeAttribute("data-nosto-rec-click");
      moreBtn.removeAttribute("data-nosto-product-id");
      moreBtn.removeAttribute("data-nosto-ref");
    } else {
      moreBtn.setAttribute("data-nosto-rec-click", "1");
      moreBtn.setAttribute("data-nosto-product-id", colorData.id);
      moreBtn.setAttribute("data-nosto-ref", carousel);
      moreBtn.setAttribute(
        "onclick",
        `window.recordRecClick('${colorData.id}', this.href, '${carousel}', event)`
      );
    }
  }
};

function buildProductCardPriceHtml(productColor) {
  let priceHtml = "";

  if (globalDiscount) {
    if (productColor.compareAtPrice) {
      priceHtml = `
        <p style="color:#D12B38;">$${productColor.price}0</p>
        <p><del>${productColor.compareAtPrice}</del></p>
      `;
    } else {
      priceHtml = `
        <p style="color:#D12B38;">$${(productColor.price * 0.85).toFixed(2)}</p>
        <p><del>$${productColor.price}0</del></p>
      `;
    }
  } else if (productColor.compareAtPrice) {
    priceHtml = `
      <p style="color:#D12B38;">$${productColor.price}0</p>
      <p><del>${productColor.compareAtPrice}</del></p>
    `;
  } else {
    priceHtml = `<p>$${productColor.price}0</p>`;
  }
//productColor.tagMasVendido
  const masVendidoHtml = productColor.tagMasVendido ? `
    <div class="product-badge-vendidos-plp">
 <svg viewBox="0 0 150 30" fill="none" xmlns="http://www.w3.org/2000/svg">

<g clip-path="url(#clip0_93_10)">

<rect width="29.1925" height="149.831" rx="14.5963" transform="matrix(-0.00587498 0.999983 -0.999985 -0.00539269 150 0.807983)" fill="#E5F5FF"/>

<path d="M24.7899 18.8033L24.7658 10.4033L26.0498 10.4L29.7394 16.5223L29.0674 16.5241L32.6618 10.3826L33.9458 10.3792L33.9819 18.7791L32.5059 18.783L32.4764 12.6991L32.7884 12.6983L29.7312 17.8303L29.0352 17.8321L25.9004 12.7164L26.2604 12.7154L26.2779 18.7994L24.7899 18.8033ZM36.2628 18.7731L40.0187 10.3632L41.5547 10.3592L45.3708 18.7492L43.7388 18.7535L40.4651 11.1901L41.0891 11.1884L37.8708 18.7689L36.2628 18.7731ZM37.9972 16.8246L38.4137 15.5995L42.9497 15.5875L43.3732 16.8104L37.9972 16.8246ZM39.7767 9.67986L41.392 8.0316L43.156 8.02696L41.0727 9.67645L39.7767 9.67986ZM50.2434 18.8564C49.5874 18.8581 48.9592 18.7677 48.3586 18.5853C47.7581 18.3949 47.2814 18.1521 46.9285 17.8571L47.465 16.6437C47.8018 16.9068 48.2184 17.1257 48.7149 17.3004C49.2114 17.4751 49.7197 17.5617 50.2397 17.5604C50.6797 17.5592 51.0356 17.5103 51.3073 17.4136C51.579 17.3168 51.7786 17.1883 51.9062 17.028C52.0337 16.8596 52.0971 16.6715 52.0965 16.4635C52.0958 16.2075 52.0032 16.0037 51.8188 15.8522C51.6343 15.6927 51.394 15.5693 51.0977 15.4821C50.8094 15.3869 50.4852 15.2997 50.125 15.2207C49.7727 15.1416 49.4165 15.0505 49.0562 14.9475C48.7039 14.8364 48.3795 14.6972 48.083 14.53C47.7945 14.3548 47.5578 14.1234 47.373 13.8359C47.1881 13.5484 47.0951 13.1806 47.0938 12.7326C47.0925 12.2766 47.2113 11.8603 47.4502 11.4837C47.6971 11.099 48.0682 10.794 48.5636 10.5687C49.0669 10.3354 49.7026 10.2177 50.4706 10.2157C50.9746 10.2144 51.4748 10.2771 51.9711 10.4038C52.4675 10.5305 52.9 10.7133 53.2687 10.9524L52.7802 12.1657C52.4036 11.9426 52.0151 11.7797 51.6148 11.6767C51.2145 11.5658 50.8303 11.5108 50.4623 11.5118C50.0303 11.5129 49.6785 11.5658 49.4068 11.6705C49.1431 11.7752 48.9474 11.9117 48.8199 12.0801C48.7004 12.2484 48.641 12.4405 48.6416 12.6565C48.6423 12.9125 48.7309 13.1203 48.9074 13.2798C49.0918 13.4314 49.3282 13.5507 49.6164 13.638C49.9127 13.7252 50.2409 13.8123 50.6012 13.8994C50.9614 13.9784 51.3177 14.0695 51.67 14.1726C52.0303 14.2756 52.3546 14.4108 52.6431 14.578C52.9396 14.7452 53.1763 14.9726 53.3531 15.2602C53.5379 15.5477 53.631 15.9114 53.6322 16.3514C53.6335 16.7994 53.5107 17.2158 53.2638 17.6004C53.0249 17.977 52.6538 18.282 52.1504 18.5153C51.6471 18.7407 51.0114 18.8543 50.2434 18.8564ZM63.3863 18.7018L59.6902 10.3115L61.3822 10.307L64.68 17.8944L63.708 17.8969L66.9981 10.2922L68.5581 10.2881L64.9223 18.6977L63.3863 18.7018ZM72.0946 13.7709L76.2706 13.7599L76.2743 15.0439L72.0983 15.0548L72.0946 13.7709ZM72.2249 17.3705L76.9649 17.3581L76.9687 18.666L70.6687 18.6826L70.6445 10.2827L76.7765 10.2665L76.7803 11.5745L72.2083 11.5865L72.2249 17.3705ZM79.9077 18.6583L79.8836 10.2583L81.1676 10.255L86.4541 16.7091L85.8181 16.7108L85.7995 10.2428L87.3475 10.2387L87.3717 18.6387L86.0877 18.6421L80.8011 12.1879L81.4371 12.1863L81.4557 18.6542L79.9077 18.6583ZM90.8225 18.6296L90.7984 10.2296L94.4704 10.22C95.3824 10.2176 96.1829 10.3915 96.8719 10.7417C97.5609 11.0918 98.0983 11.5784 98.4841 12.2014C98.8699 12.8244 99.064 13.5599 99.0664 14.4079C99.0688 15.2479 98.879 15.9844 98.4968 16.6174C98.1146 17.2424 97.58 17.7318 96.893 18.0856C96.206 18.4394 95.4065 18.6175 94.4945 18.6199L90.8225 18.6296ZM92.3787 17.3055L94.4187 17.3001C95.0507 17.2985 95.5944 17.177 96.0497 16.9358C96.513 16.6946 96.868 16.3577 97.1148 15.925C97.3695 15.4924 97.4961 14.988 97.4944 14.412C97.4928 13.828 97.3633 13.3244 97.1061 12.901C96.8568 12.4697 96.4999 12.1346 96.0352 11.8959C95.5785 11.6571 95.0342 11.5385 94.4022 11.5402L92.3622 11.5455L92.3787 17.3055ZM101.937 18.6004L101.912 10.2004L103.472 10.1963L103.497 18.5963L101.937 18.6004ZM106.969 18.5871L106.944 10.1872L110.616 10.1775C111.528 10.1751 112.329 10.349 113.018 10.6992C113.707 11.0494 114.244 11.536 114.63 12.1589C115.016 12.7819 115.21 13.5174 115.212 14.3654C115.215 15.2054 115.025 15.9419 114.643 16.5749C114.261 17.1999 113.726 17.6893 113.039 18.0432C112.352 18.397 111.553 18.5751 110.641 18.5775L106.969 18.5871ZM108.525 17.263L110.565 17.2577C111.197 17.256 111.74 17.1346 112.196 16.8934C112.659 16.6521 113.014 16.3152 113.261 15.8826C113.516 15.4499 113.642 14.9456 113.64 14.3696C113.639 13.7856 113.509 13.2819 113.252 12.8586C113.003 12.4272 112.646 12.0922 112.181 11.8534C111.725 11.6146 111.18 11.496 110.548 11.4977L108.508 11.503L108.525 17.263ZM122.019 18.6675C121.363 18.6693 120.759 18.5628 120.206 18.3483C119.653 18.1338 119.173 17.835 118.763 17.4521C118.354 17.0612 118.037 16.606 117.811 16.0866C117.586 15.5592 117.472 14.9835 117.471 14.3595C117.469 13.7355 117.579 13.1632 117.802 12.6426C118.024 12.114 118.339 11.6572 118.746 11.2721C119.153 10.879 119.632 10.5738 120.183 10.3563C120.734 10.1389 121.334 10.0293 121.982 10.0276C122.638 10.0259 123.238 10.1323 123.783 10.3469C124.336 10.5614 124.816 10.8641 125.226 11.2551C125.635 11.638 125.952 12.0932 126.178 12.6206C126.403 13.14 126.517 13.7117 126.518 14.3357C126.52 14.9597 126.41 15.536 126.187 16.0646C125.965 16.5931 125.65 17.05 125.243 17.435C124.836 17.8201 124.357 18.1214 123.806 18.3388C123.263 18.5563 122.667 18.6658 122.019 18.6675ZM122.003 17.2996C122.427 17.2985 122.819 17.2254 123.178 17.0805C123.538 16.9355 123.849 16.7307 124.113 16.466C124.376 16.1933 124.579 15.8808 124.722 15.5284C124.873 15.168 124.948 14.7718 124.946 14.3398C124.945 13.9078 124.868 13.516 124.715 13.1644C124.57 12.8048 124.365 12.4933 124.1 12.23C123.836 11.9587 123.523 11.7515 123.163 11.6085C122.802 11.4654 122.41 11.3945 121.986 11.3956C121.562 11.3967 121.17 11.4697 120.811 11.6147C120.459 11.7596 120.148 11.9684 119.876 12.2411C119.613 12.5058 119.406 12.8184 119.255 13.1788C119.112 13.5312 119.041 13.9233 119.043 14.3553C119.044 14.7793 119.117 15.1712 119.262 15.5308C119.415 15.8904 119.624 16.2058 119.889 16.4771C120.153 16.7404 120.466 16.9436 120.826 17.0867C121.187 17.2297 121.579 17.3007 122.003 17.2996Z" fill="#3B85AB"/>

</g>

<defs>

<clipPath id="clip0_93_10">

<rect width="150" height="30" fill="white"/>

</clipPath>

</defs>

</svg>
    </div>
  ` : "";

  const pocasPiezasHtml = (!productColor.tagMasVendido && productColor.stock <= 2 && productColor.stock > 0) ? `
    <div class="product-badge-vendidos-plp pocas_piezas_value-plp">
      <svg viewBox="0 0 150 30" fill="none" xmlns="http://www.w3.org/2000/svg">

<g clip-path="url(#clip0_93_9)">

<rect width="29.1925" height="149.831" rx="14.5963" transform="matrix(-0.00587498 0.999983 -0.999985 -0.00539269 150 0.807983)" fill="#FF0004" fill-opacity="0.14"/>

<path d="M23.5989 20.1688L23.5748 11.7688L27.0308 11.7597C27.7748 11.7578 28.4111 11.8761 28.9398 12.1147C29.4765 12.3533 29.8895 12.6962 30.1788 13.1434C30.4681 13.5907 30.6136 14.1223 30.6154 14.7383C30.6171 15.3543 30.4747 15.8867 30.188 16.3354C29.9012 16.7842 29.4902 17.1293 28.9549 17.3707C28.4276 17.6121 27.792 17.7337 27.048 17.7357L24.456 17.7425L25.1499 17.0087L25.1589 20.1647L23.5989 20.1688ZM25.1503 17.1767L24.4522 16.4225L26.9722 16.4159C27.6602 16.4141 28.1758 16.2687 28.5189 15.9798C28.8701 15.6829 29.0449 15.2704 29.0434 14.7424C29.0418 14.2064 28.8647 13.7949 28.5118 13.5078C28.167 13.2207 27.6506 13.0781 26.9626 13.0799L24.4426 13.0866L25.1364 12.3167L25.1503 17.1767ZM37.4423 20.2523C36.7863 20.2541 36.182 20.1476 35.6293 19.9331C35.0767 19.7186 34.5959 19.4198 34.1868 19.0369C33.7776 18.646 33.4603 18.1908 33.2348 17.6714C33.0093 17.144 32.8957 16.5683 32.8939 15.9443C32.8921 15.3203 33.0024 14.748 33.2249 14.2274C33.4474 13.6988 33.7621 13.242 34.169 12.8569C34.5759 12.4638 35.055 12.1586 35.6064 11.9411C36.1578 11.7237 36.7575 11.6141 37.4055 11.6124C38.0615 11.6107 38.6618 11.7171 39.2064 11.9316C39.759 12.1462 40.2399 12.4489 40.649 12.8398C41.0581 13.2228 41.3754 13.6779 41.6009 14.2053C41.8264 14.7247 41.94 15.2965 41.9418 15.9205C41.9436 16.5444 41.8333 17.1207 41.6108 17.6493C41.3883 18.1779 41.0736 18.6347 40.6667 19.0198C40.2598 19.4049 39.7807 19.7062 39.2293 19.9236C38.6859 20.141 38.0903 20.2506 37.4423 20.2523ZM37.4263 18.8844C37.8503 18.8832 38.2421 18.8102 38.6017 18.6653C38.9613 18.5203 39.2727 18.3155 39.5359 18.0508C39.7992 17.7781 40.0023 17.4656 40.1453 17.1132C40.2962 16.7528 40.3711 16.3566 40.3698 15.9246C40.3686 15.4926 40.2915 15.1008 40.1385 14.7492C39.9934 14.3896 39.7885 14.0781 39.5238 13.8148C39.259 13.5435 38.9464 13.3363 38.586 13.1933C38.2256 13.0502 37.8334 12.9793 37.4094 12.9804C36.9854 12.9815 36.5936 13.0545 36.234 13.1995C35.8824 13.3444 35.571 13.5532 35.2998 13.8259C35.0366 14.0906 34.8295 14.4032 34.6785 14.7636C34.5355 15.116 34.4646 15.5082 34.4659 15.9402C34.4671 16.3641 34.5402 16.756 34.6852 17.1156C34.8383 17.4752 35.0472 17.7906 35.312 18.0619C35.5767 18.3252 35.8893 18.5284 36.2497 18.6715C36.6101 18.8145 37.0023 18.8855 37.4263 18.8844ZM48.6958 20.2227C48.0558 20.2244 47.4595 20.1219 46.9069 19.9154C46.3623 19.7008 45.8854 19.4021 45.4763 19.0191C45.0752 18.6282 44.7619 18.169 44.5364 17.6416C44.3108 17.1142 44.1972 16.5385 44.1954 15.9145C44.1936 15.2905 44.3039 14.7142 44.5264 14.1856C44.7489 13.657 45.0636 13.2002 45.4705 12.8151C45.8774 12.4221 46.3525 12.1208 46.8959 11.9114C47.4393 11.6939 48.035 11.5844 48.683 11.5827C49.371 11.5809 49.9993 11.6992 50.568 11.9377C51.1367 12.1682 51.6177 12.5149 52.011 12.9779L51.0057 13.9286C50.7008 13.6014 50.3601 13.3583 49.9836 13.1992C49.6071 13.0322 49.1989 12.9493 48.7589 12.9505C48.3189 12.9516 47.9151 13.0247 47.5475 13.1697C47.1879 13.3146 46.8725 13.5194 46.6013 13.7842C46.338 14.0489 46.1309 14.3614 45.98 14.7218C45.837 15.0822 45.7661 15.4784 45.7674 15.9104C45.7686 16.3424 45.8418 16.7382 45.9868 17.0978C46.1398 17.4574 46.3487 17.7688 46.6135 18.0321C46.8862 18.2954 47.2028 18.4986 47.5632 18.6416C47.9316 18.7847 48.3359 18.8556 48.7759 18.8545C49.2159 18.8533 49.6236 18.7722 49.9992 18.6112C50.3747 18.4422 50.714 18.1893 51.017 17.8525L52.0277 18.8099C51.637 19.2669 51.158 19.6162 50.5907 19.8577C50.0234 20.0992 49.3918 20.2208 48.6958 20.2227ZM53.3624 20.0904L57.1183 11.6804L58.6543 11.6764L62.4704 20.0664L60.8384 20.0707L57.5646 12.5073L58.1886 12.5056L54.9704 20.0861L53.3624 20.0904ZM55.0968 18.1418L55.5133 16.9167L60.0493 16.9047L60.4728 18.1276L55.0968 18.1418ZM67.343 20.1735C66.687 20.1753 66.0587 20.0849 65.4582 19.9025C64.8576 19.7121 64.3809 19.4693 64.0281 19.1743L64.5646 17.9608C64.9014 18.224 65.318 18.4429 65.8145 18.6176C66.311 18.7922 66.8192 18.8789 67.3392 18.8775C67.7792 18.8764 68.1351 18.8274 68.4068 18.7307C68.6786 18.634 68.8782 18.5055 69.0057 18.3451C69.1332 18.1768 69.1967 17.9886 69.1961 17.7806C69.1954 17.5246 69.1028 17.3209 68.9183 17.1694C68.7339 17.0099 68.4935 16.8865 68.1973 16.7993C67.909 16.704 67.5848 16.6169 67.2245 16.5378C66.8723 16.4588 66.516 16.3677 66.1557 16.2646C65.8034 16.1536 65.479 16.0144 65.1825 15.8472C64.894 15.672 64.6574 15.4406 64.4725 15.1531C64.2877 14.8656 64.1947 14.4978 64.1934 14.0498C64.1921 13.5938 64.3109 13.1775 64.5498 12.8009C64.7967 12.4162 65.1678 12.1112 65.6632 11.8859C66.1665 11.6526 66.8022 11.5349 67.5702 11.5329C68.0742 11.5316 68.5743 11.5943 69.0707 11.7209C69.5671 11.8476 69.9996 12.0305 70.3683 12.2695L69.8798 13.4828C69.5031 13.2598 69.1147 13.0968 68.7144 12.9939C68.314 12.8829 67.9299 12.828 67.5619 12.8289C67.1299 12.8301 66.778 12.883 66.5063 12.9877C66.2426 13.0924 66.047 13.2289 65.9195 13.3973C65.8 13.5656 65.7405 13.7577 65.7412 13.9737C65.7419 14.2297 65.8305 14.4375 66.007 14.597C66.1914 14.7485 66.4277 14.8679 66.716 14.9552C67.0122 15.0424 67.3405 15.1295 67.7007 15.2166C68.061 15.2956 68.4172 15.3867 68.7695 15.4898C69.1298 15.5928 69.4542 15.728 69.7427 15.8952C70.0392 16.0624 70.2758 16.2898 70.4527 16.5773C70.6375 16.8648 70.7305 17.2286 70.7318 17.6686C70.7331 18.1166 70.6103 18.5329 70.3634 18.9176C70.1245 19.2942 69.7533 19.5992 69.25 19.8325C68.7466 20.0578 68.111 20.1715 67.343 20.1735ZM78.0019 20.0254L77.9778 11.6255L81.4337 11.6164C82.1777 11.6144 82.8141 11.7327 83.3428 11.9713C83.8795 12.2099 84.2924 12.5528 84.5817 13.0001C84.871 13.4473 85.0165 13.9789 85.0183 14.5949C85.0201 15.2109 84.8776 15.7433 84.5909 16.1921C84.3042 16.6408 83.8932 16.9859 83.3579 17.2273C82.8305 17.4687 82.1949 17.5904 81.4509 17.5923L78.8589 17.5992L79.5528 16.8653L79.5619 20.0213L78.0019 20.0254ZM79.5533 17.0333L78.8551 16.2792L81.3751 16.2725C82.0631 16.2707 82.5787 16.1254 82.9219 15.8365C83.273 15.5395 83.4478 15.1271 83.4463 14.5991C83.4448 14.0631 83.2676 13.6515 82.9148 13.3645C82.5699 13.0774 82.0535 12.9347 81.3655 12.9366L78.8455 12.9432L79.5393 12.1734L79.5533 17.0333ZM87.7917 19.9996L87.7676 11.5997L89.3276 11.5956L89.3517 19.9955L87.7917 19.9996ZM94.2496 15.0746L98.4256 15.0636L98.4293 16.3476L94.2533 16.3586L94.2496 15.0746ZM94.3799 18.6743L99.1199 18.6618L99.1237 19.9698L92.8237 19.9864L92.7996 11.5864L98.9316 11.5703L98.9353 12.8783L94.3633 12.8903L94.3799 18.6743ZM101.427 19.9637L101.424 18.9197L106.829 12.2815L107.01 12.869L101.49 12.8835L101.487 11.5635L108.411 11.5453L108.414 12.5893L103.009 19.2275L102.815 18.6401L108.587 18.6248L108.591 19.9448L101.427 19.9637ZM110.032 19.941L113.788 11.5311L115.324 11.5271L119.14 19.917L117.508 19.9213L114.234 12.3579L114.858 12.3563L111.64 19.9368L110.032 19.941ZM111.766 17.9925L112.183 16.7674L116.719 16.7554L117.142 17.9783L111.766 17.9925ZM124.012 20.0242C123.356 20.0259 122.728 19.9356 122.128 19.7532C121.527 19.5627 121.05 19.32 120.697 19.0249L121.234 17.8115C121.571 18.0746 121.987 18.2935 122.484 18.4682C122.98 18.6429 123.489 18.7296 124.009 18.7282C124.449 18.727 124.804 18.6781 125.076 18.5814C125.348 18.4847 125.548 18.3561 125.675 18.1958C125.803 18.0275 125.866 17.8393 125.865 17.6313C125.865 17.3753 125.772 17.1716 125.588 17.02C125.403 16.8605 125.163 16.7372 124.867 16.6499C124.578 16.5547 124.254 16.4675 123.894 16.3885C123.542 16.3094 123.185 16.2184 122.825 16.1153C122.473 16.0042 122.148 15.8651 121.852 15.6979C121.563 15.5226 121.327 15.2913 121.142 15.0037C120.957 14.7162 120.864 14.3485 120.863 13.9005C120.861 13.4445 120.98 13.0282 121.219 12.6515C121.466 12.2669 121.837 11.9619 122.332 11.7366C122.836 11.5033 123.471 11.3856 124.239 11.3836C124.743 11.3822 125.244 11.4449 125.74 11.5716C126.236 11.6983 126.669 11.8812 127.038 12.1202L126.549 13.3335C126.172 13.1105 125.784 12.9475 125.384 12.8446C124.983 12.7336 124.599 12.6786 124.231 12.6796C123.799 12.6807 123.447 12.7337 123.176 12.8384C122.912 12.9431 122.716 13.0796 122.589 13.2479C122.469 13.4162 122.41 13.6084 122.41 13.8244C122.411 14.0804 122.5 14.2882 122.676 14.4477C122.861 14.5992 123.097 14.7186 123.385 14.8058C123.682 14.8931 124.01 14.9802 124.37 15.0672C124.73 15.1463 125.087 15.2374 125.439 15.3404C125.799 15.4435 126.124 15.5786 126.412 15.7459C126.709 15.9131 126.945 16.1405 127.122 16.428C127.307 16.7155 127.4 17.0793 127.401 17.5193C127.402 17.9673 127.28 18.3836 127.033 18.7682C126.794 19.1449 126.423 19.4498 125.919 19.6832C125.416 19.9085 124.78 20.0222 124.012 20.0242Z" fill="#B60003"/>

</g>

<defs>

<clipPath id="clip0_93_9">

<rect width="150" height="30" fill="white"/>

</clipPath>

</defs>

</svg>
    </div>
  ` : "";

  return `
    ${priceHtml}
    ${masVendidoHtml}
    ${pocasPiezasHtml}
  `;
}

function buildCardSwatches({ productColors, carousel, product, source, attributionKey }) {

  const visibleColors = productColors.slice(0, 3);
  const hiddenCount = Math.max(productColors.length - 3, 0);

  return `
    <div class="card-color-swatches">
      ${visibleColors.map((productColor, index) => `
        <button
          type="button"
          class="swatch swatch-${productColor.class} card-color-swatch ${index === 0 ? "is-active" : ""}"
          data-color-id="${productColor.id}"
          aria-label="${escapeHtml(productColor.color)}"
          title="${escapeHtml(productColor.color)}"
          onclick="window.changeProductCardColor(event, this)"
        ></button>
      `).join("")}

      ${hiddenCount > 0 ? `
        <a
          class="card-color-more"
          href="${buildProductCardHref({
            source,
            productColor: productColors[0],
            attributionKey,
            carousel
          })}"
          ${source === "nostosearch"
            ? `onclick="window.recordClick('serp','${productColors[0].id}')"`
            : source === "category"
            ? `onclick="window.recordClick('category','${productColors[0].id}')"`
            : `data-nosto-rec-click="1"
               data-nosto-product-id="${productColors[0].id}"
               data-nosto-ref="${carousel}"
               onclick="window.recordRecClick('${productColors[0].id}', this.href, '${carousel}', event)"`}
        >+${hiddenCount}</a>
      ` : ""}
    </div>
  `;
}
function getHandleFromUrl(url) {
  try {
    const afterProducts = url.split('/products/')[1] || '';
    return afterProducts.split('?')[0].replace(/\/$/, '');
  } catch { return ''; }
}

// Helper: arma el <button> wishlist con todos los data-*
function buildWishlistButton({ product, productColor, isLoggedIn }) {
  // Primer variant para data-wishlist__variant (si existe)
  const firstVariantId = (productColor.variants && productColor.variants[0])
    ? productColor.variants[0].id
    : '';

  // URL absoluta al producto (como hacía Liquid con shop.url + product.url)
  const productUrl = productColor.url;

  // Image URL ~600x600 (equivalente a | img_url: '600x600')
  const imageUrl = `${productColor.image}&width=600&height=600&crop=center`;

  // Categorías: si no las tienes en JS, deja vendor o vacío
  const categories = Array.isArray(product.collections)
    ? product.collections.map(c => c.title).join(',')
    : (product.vendor || '');

  // Click según login
  const onClick = isLoggedIn ? 'js_wishlist__add(this)' : 'js_wishlist__account()';

  return `
    <button
      class="c-button-wishlist cutom-wish-button"
      aria-label="Add to wishlist"
      onclick="${onClick}"
      data-wishlist__active="false"
      data-wishlist__id="${product.id}"
      data-wishlist__variant="${firstVariantId}"
      data-wishlist__handle="${getHandleFromUrl(productUrl)}"

      data-productname="${String(product.title).replace(/"/g, '&quot;')}"
      data-productid="${product.id}"
      data-producturl="${productUrl}"
      data-imageurl="${imageUrl}"
      data-price="${productColor.price}" 
      data-categories="${categories}"
    >
      <svg aria-hidden="true" focusable="false" fill="none" stroke-width="" width="24" class="" viewBox="0 0 24 24"> <path clip-rule="evenodd" d="m12 21.844-9.588-10a5.672 5.672 0 0 1-1.063-6.551v0a5.673 5.673 0 0 1 9.085-1.474L12 5.384l1.566-1.565a5.673 5.673 0 0 1 9.085 1.474v0a5.673 5.673 0 0 1-1.062 6.548L12 21.844Z" stroke="currentColor" stroke-linecap="round" fill="none" stroke-linejoin="round" stroke-width="2"></path> </svg>
    </button>
  `;
}


window.recordRecClick = (productId, productUrl, attributionKey, evt) => {
  try {
    if (!attributionKey) return; 
    const payload = {
      productId: String(productId || ""),
      ref: String(attributionKey || ""), 
      ts: Date.now(),
      from: window.location.href,
      to: String(productUrl || ""),
    };
    localStorage.setItem("__nosto_last_rec_click", JSON.stringify(payload));
  } catch (e) {
    console.warn("recordRecClick: no se pudo guardar contexto:", e);
  }
};
document.addEventListener("contextmenu", (e) => {
  const a = e.target?.closest?.("a[data-nosto-rec-click]");
  if (!a) return;

  const productId = a.getAttribute("data-nosto-product-id");
  const ref = a.getAttribute("data-nosto-ref");
  const href = a.getAttribute("href");

  window.recordRecClick(productId, href, ref);
});





window.quickAddState = {
  selectedVariantId: null,
  selectedColorId: null,
  containerId: null,
  attribution: "",
  source: "",
  productUrl: "",
  variants: [],
  colors: [],
  title: "",
  colorsExpanded: false,
};

function escapeHtml(str) {
  return String(str ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
}
//Modal de compra en mobile
function ensureQuickAddModal() {
  if (document.getElementById("quickAddModal")) return;

  const modalHtml = `
    <div id="quickAddModal" class="quick-add-modal" aria-hidden="true">
  <div class="quick-add-modal__backdrop" onclick="closeProductQuickAdd()"></div>

  <div
    class="quick-add-modal__panel"
    role="dialog"
    aria-modal="true"
    aria-label="Añadir a la bolsa"
  >
    <button
      type="button"
      class="quick-add-modal__close"
      aria-label="Cerrar"
      onclick="closeProductQuickAdd()"
    >
      ×
    </button>

    <div class="quick-add-modal__handle"></div>

    <div class="quick-add-modal__top">
      <button
        type="button"
        class="quick-add-modal__image-link"
        onclick="goToProductFromQuickAdd(event)"
        aria-label="Ir al producto"
      >
        <img id="quickAddModalImage" class="quick-add-modal__image" src="" alt="" />
      </button>

      <div class="quick-add-modal__info">
        <div id="quickAddModalTitle" class="quick-add-modal__title"></div>
        <div id="quickAddModalPriceWrap" class="quick-add-modal__price-wrap"></div>

        <div class="quick-add-modal__colors-block">
          <div class="quick-add-modal__colors-title">
            Color: <span id="quickAddModalColorName"></span>
          </div>
          <div id="quickAddModalColors" class="quick-add-modal__colors"></div>
        </div>
      </div>
    </div>

    <div class="quick-add-modal__sizes-block">
      <div id="quickAddModalSizes" class="quick-add-modal__sizes"></div>
    </div>

    <button
      type="button"
      id="quickAddModalSubmit"
      class="quick-add-modal__submit"
      onclick="submitProductQuickAdd(this)"
      disabled
    >
      <span class="quick-add-submit-text">Añadir a la bolsa</span>
      <span class="quick-add-submit-spinner" aria-hidden="true"></span>
    </button>
  </div>
</div>
  `;

  document.body.insertAdjacentHTML("beforeend", modalHtml);
}

function openProductQuickAdd(event, button) {
  event.preventDefault();
  event.stopPropagation();

  if (!button || button.classList.contains("is-loading")) return;

  button.classList.add("is-loading");
  button.disabled = true;

  ensureQuickAddModal();

  const productId = button.dataset.productId || "";
  const modal = document.getElementById("quickAddModal");
  const title = decodeURIComponent(button.dataset.title || "");
  const colors = JSON.parse(decodeURIComponent(button.dataset.colors || "[]"));
  const selectedColorId = button.dataset.selectedColorId || colors[0]?.id || "";
  const containerId = button.dataset.containerId || "";
  const attribution = decodeURIComponent(button.dataset.attribution || "");
  const source = button.dataset.source || "";

  window.quickAddState = {
    selectedVariantId: null,
    selectedColorId,
    containerId,
    attribution,
    source,
    productUrl: "",
    variants: [],
    colors,
    title,
    colorsExpanded: false,
    productId,
  };

  document.getElementById("quickAddModalTitle").textContent = title;

  renderQuickAddColors();
  updateQuickAddModalFromColor(selectedColorId);

  setTimeout(() => {
    button.classList.remove("is-loading");
    button.disabled = false;

    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add("quick-add-open");
  }, 500);
}


function renderQuickAddColors() {
  const colorsEl = document.getElementById("quickAddModalColors");
  if (!colorsEl) return;

  const { colors, selectedColorId, colorsExpanded } = window.quickAddState;
  const visibleColors = colorsExpanded ? colors : colors.slice(0, 6);
  const hiddenCount = Math.max(colors.length - 6, 0);

  colorsEl.innerHTML = `
    ${visibleColors.map((color) => `
      <button
        type="button"
        class="swatch swatch-${color.class} quick-add-modal__color-swatch ${String(color.id) === String(selectedColorId) ? "is-selected" : ""}"
        data-color-id="${color.id}"
        title="${escapeHtml(color.color)}"
        aria-label="${escapeHtml(color.color)}"
        onclick="selectQuickAddColor(event, this)"
      ></button>
    `).join("")}
    <button
      type="button"
      class="quick-add-modal__more-colors"
      onclick="goToProductFromQuickAdd(event)"
    >
      Ver detalles
    </button>
  `;
}

function expandQuickAddColors(event) {
  event.preventDefault();
  event.stopPropagation();

  window.quickAddState.colorsExpanded = true;
  renderQuickAddColors();
}

function buildQuickAddProductUrl() {
  const { productUrl, selectedVariantId } = window.quickAddState;

  if (!productUrl) return "";

  const url = new URL(productUrl, window.location.origin);

  if (selectedVariantId) {
    url.searchParams.set("variant", selectedVariantId);
  }

  return url.toString();
}

function selectQuickAddColor(event, button) {
  event.preventDefault();
  event.stopPropagation();

  const colorId = button.dataset.colorId;
  updateQuickAddModalFromColor(colorId);
}

function updateQuickAddModalFromColor(colorId) {
  const colorData = window.quickAddState.colors.find(
    (color) => String(color.id) === String(colorId)
  ) || window.quickAddState.colors[0];

  if (!colorData) return;

  const imageEl = document.getElementById("quickAddModalImage");
  const priceWrapEl = document.getElementById("quickAddModalPriceWrap");
  const colorNameEl = document.getElementById("quickAddModalColorName");

  window.quickAddState.selectedColorId = colorData.id;
  window.quickAddState.productUrl = colorData.url || "";
  window.quickAddState.variants = colorData.variants || [];

  imageEl.src = colorData.image || "";
  imageEl.alt = `${window.quickAddState.title} - ${colorData.color || ""}`;

  priceWrapEl.innerHTML = colorData.compareAtPrice
  ? `<span>$${escapeHtml(colorData.price)}</span><span class="compare">${escapeHtml(colorData.compareAtPrice)}</span>`
  : globalDiscount
    ? `<span>$${escapeHtml((Number(colorData.price) * 0.85).toFixed(2))}</span><span class="compare">$${escapeHtml(colorData.price)}0</span>`
    : `<span>$${escapeHtml(colorData.price)}</span>`;

  colorNameEl.textContent = colorData.color || "";

  renderQuickAddColors();
  renderQuickAddSizes(colorData.variants || []);
}

function renderQuickAddSizes(variants) {
  const sizesEl = document.getElementById("quickAddModalSizes");
  const submitEl = document.getElementById("quickAddModalSubmit");

  sizesEl.innerHTML = "";

  if (!variants.length) {
    sizesEl.innerHTML = `<div class="quick-add-modal__size is-disabled">Agotado</div>`;
    window.quickAddState.selectedVariantId = null;
    submitEl.disabled = true;
    return;
  }
// size order
  const sizeOrder = {
    XCH: 0,
    CH: 1,
    M: 2,
    G: 3,
    XG: 4,
  };

  const sortedVariants = [...variants].sort((a, b) => {
    const sizeA = a.title.trim().toUpperCase();
    const sizeB = b.title.trim().toUpperCase();

    const orderA = sizeOrder[sizeA] ?? Number.MAX_SAFE_INTEGER;
    const orderB = sizeOrder[sizeB] ?? Number.MAX_SAFE_INTEGER;

    return orderA - orderB;
  });

  sizesEl.innerHTML = sortedVariants
    .map((variant, index) => {
      return `
        <button
          type="button"
          class="quick-add-modal__size ${index === 0 ? "is-selected" : ""}"
          data-variant-id="${variant.id}"
          onclick="selectQuickAddSize(event, this)"
        >
          ${escapeHtml(variant.title)}
        </button>
      `;
    })
    .join("");

  window.quickAddState.selectedVariantId = sortedVariants[0].id;
  submitEl.disabled = false;
}

function selectQuickAddSize(event, button) {
  event.preventDefault();
  event.stopPropagation();

  const sizesWrap = document.getElementById("quickAddModalSizes");
  sizesWrap.querySelectorAll(".quick-add-modal__size").forEach((el) => {
    el.classList.remove("is-selected");
  });

  button.classList.add("is-selected");
  window.quickAddState.selectedVariantId = button.dataset.variantId;

  const submitEl = document.getElementById("quickAddModalSubmit");
  submitEl.disabled = !window.quickAddState.selectedVariantId;
}

function goToProductFromQuickAdd(event) {
  event.preventDefault();
  event.stopPropagation();

  const { source, productId } = window.quickAddState;
  const targetUrl = buildQuickAddProductUrl();

  if (!targetUrl) return;

  try {
    if (source === "nostosearch") {
      window.recordClick("serp", productId);
    } else if (source === "category") {
      window.recordClick("category", productId);
    }
  } catch (e) {
    console.warn("Tracking error:", e);
  }

  window.location.href = targetUrl;
}

function closeProductQuickAdd() {
  const modal = document.getElementById("quickAddModal");
  if (!modal) return;

  modal.classList.remove("is-open");
  modal.setAttribute("aria-hidden", "true");
  document.body.classList.remove("quick-add-open");

  window.quickAddState = {
    selectedVariantId: null,
    selectedColorId: null,
    containerId: null,
    attribution: "",
    source: "",
    productUrl: "",
    variants: [],
    colors: [],
    title: "",
    colorsExpanded: false,
  };
}

function submitProductQuickAdd(button) {
  const state = window.quickAddState;
  if (!state || !state.selectedVariantId || !button) return;

  button.classList.add("is-loading");
  button.disabled = true;

  cart.add(
    state.selectedVariantId,
    state.selectedColorId,
    state.attribution,
    state.source,
    button
  );
}

document.addEventListener("keydown", function (event) {
  if (event.key === "Escape") {
    closeProductQuickAdd();
  }
});

document.addEventListener('DOMContentLoaded', function() {
  ensureQuickAddModal();
});